module.exports = __webpack_public_path__ + "static/assets/ef17361e020093f1265f54eec501c969.svg";